import { render, staticRenderFns } from "./deleteExamDialog.vue?vue&type=template&id=42d7a5d0&scoped=true"
import script from "./deleteExamDialog.vue?vue&type=script&lang=js"
export * from "./deleteExamDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d7a5d0",
  null
  
)

export default component.exports